import { z } from 'zod';
/**
 * Typed job contracts (spec §4). Jobs are persisted rows claimed
 * transactionally by the worker; payloads are validated with zod on
 * both enqueue and claim.
 */
export const JOB_TYPES = [
    'research.topics',
    'generate.title',
    'generate.script',
    'generate.reference-image',
    'generate.image',
    'generate.video-segment',
    'media.join-segments',
    'media.validate',
    'generate.caption',
    'generate.thumbnail',
    'review.content',
    'schedule.content',
    'publish.image-post',
    'publish.reel',
    'facebook.poll-processing',
    'facebook.fetch-metrics',
    'facebook.validate-token',
    'facebook.refresh-token',
    'provider.health-check',
    'plan.daily-content',
    'maintenance.cleanup',
];
export const JOB_STATUSES = ['PENDING', 'CLAIMED', 'RUNNING', 'SUCCEEDED', 'FAILED', 'RETRY_WAIT', 'BLOCKED', 'CANCELLED'];
export const jobEnvelopeSchema = z.object({
    jobType: z.enum(JOB_TYPES),
    pageId: z.string().uuid().nullable(),
    contentItemId: z.string().uuid().nullable(),
    workflowId: z.string().uuid().nullable(),
    idempotencyKey: z.string().min(8),
    payload: z.record(z.unknown()),
});
export const DEFAULT_RETRY_POLICIES = {
    default: { maxAttempts: 4, baseDelayMs: 30_000, maxDelayMs: 3_600_000, factor: 3 },
    publish: { maxAttempts: 5, baseDelayMs: 60_000, maxDelayMs: 7_200_000, factor: 2.5 },
    'provider.health-check': { maxAttempts: 1, baseDelayMs: 0, maxDelayMs: 0, factor: 1 },
};
export function retryDelayMs(policy, attempt) {
    const raw = policy.baseDelayMs * Math.pow(policy.factor, Math.max(0, attempt - 1));
    const jitter = 0.85 + Math.random() * 0.3;
    return Math.min(policy.maxDelayMs, Math.round(raw * jitter));
}
//# sourceMappingURL=jobs.js.map